import { useMutation } from '@tanstack/react-query'
import { changePassword } from '../index'

const useChangePassword = () =>
  useMutation({
    mutationFn: changePassword,
  })

export default useChangePassword
